const actionTypes = {
  ENQUEUE_FLASH_NOTIFICATION: 'ENQUEUE_FLASH_NOTIFICATION',
  DEQUEUE_FLASH_NOTIFICATION: 'DEQUEUE_FLASH_NOTIFICATION',
}

export default actionTypes
